module.exports = __webpack_public_path__ + "img/vendorproof-shadowmark@2x.14c3aef9.png";